<script>
export default {
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<template>
  <v-footer height="auto" class="flex-grow-0">
    <v-row justify="center" class="navigationButtons">
      <v-btn
        v-for="link in links"
        :key="link.name"
        :to="{ name: link.name }"
        variant="text"
        rounded
        exact
        >{{ link.title || link.name }}</v-btn
      >
      <v-btn
        href="https://bowtie8.com/contact-us?utm_source=bowvue&utm_medium=organic&utm_campaign=general&utm_term=na&utm_content=na"
        target="_blank"
        variant="text"
        rounded
        exact
        >{{ $t('components.footer.website') }}</v-btn
      >
      <v-btn
        href="https://g.page/r/CY3o0573ey2lEAI/review"
        target="_blank"
        variant="text"
        rounded
        exact
        >{{ $t('components.footer.rateUs') }}</v-btn
      >
      <v-col class="py-3 text-center" cols="12">
        &copy;2014-{{ new Date().getFullYear() }} -
        <strong>Bowtie Engineering, LLC</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>
